export default __webpack_public_path__ + "static/media/radiant-bright-blue-green.c21f807e.jpg";